exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-ContentBlock {\n  page-break-inside: avoid;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/ContentBlock/ContentBlock.less
// module id = 865
// module chunks = 0